import React, { useState } from 'react'
import BreadcrumbTitle from './common/BreadcrumbTitle'
import { Law } from '../../../../interfaces/Indicator'
import { MdOutlineShare } from 'react-icons/md'
import { GrDocumentText } from "react-icons/gr";
import Dialog from '../../../../components/Dialog/Dialog'
import Share from '../../../../components/Share/Share'
import MethodologyNoteDialog from './common/MethodologyNoteDialog'
import ResponsiveContainer from '../../../../layouts/ResponsiveContainer'
import EvaluationLaws from '../../../../components/States/EvaluationLaws'
import DownloadPDFWithFetch from '../../../../components/DownloadPDF/DownloadPDFWithFetch'
import OdsChips from '../../../../components/Mappers/OdsChips'
import PriorityGroupChips from '../../../../components/Mappers/PriorityGroupsChips'
import { useHighlightText } from '../../hooks/useHighlightText'
import Button from '../../../../components/Buttons/Button'
import { buildHrefFromBreadcrumbs } from '../../utils/buildShareHref';

type PartialLawProps = Pick<Law, 'titulo' | 'breadcrumbs' | 'descripcion' | 'ods' | 'grupos_prioritarios' | 'url' | 'pdf' | 'state' | 'id' | 'dimension' | 'subdimension'>;

const Laws = ({ titulo, breadcrumbs, ods, grupos_prioritarios, url, descripcion, pdf, state, id, dimension, subdimension }: PartialLawProps) => {
  const { highlight } = useHighlightText();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenMetodologyNote, setIsOpenMetodologyNote] = useState<boolean>(false);

  const href = buildHrefFromBreadcrumbs(breadcrumbs, id, dimension, subdimension, { typeOverride: 'Estructurales' });

  return (
    <ResponsiveContainer className='flex flex-col gap-6 border-b-2  border-[#DCE4E9] pb-8 mt-8 '>
      <BreadcrumbTitle breadcrumbs={breadcrumbs} titulo={titulo} />
      <div className='flex flex-col gap-6  md:flex-row md:justify-between'>
        {url ? (
          <a href={url} target="_blank" rel="noreferrer">
            <h2 className="text-brand-green-20 text-hlarge underline cursor-pointer transition-all duration-200 hover:text-brand-green-30">{highlight(titulo)}</h2>
          </a>
        ) : (
          <h2 className="text-brand-green-20 text-hlarge">{highlight(titulo)}</h2>
        )}
        <div className='flex justify-between gap-2'>
          <EvaluationLaws
            evaluacion={state}
            height='h-[40px]'
            width='w-full md:w-[140px]'
          />
          <div className='flex gap-2'>
            <Button
              icon={MdOutlineShare}
              onClick={() => setIsOpen(!isOpen)}
              label=""
              iconSize={22}
              variant='outline'
              showIconLeft={true}
              showIconRight={false}
              className='!px-3'
            />
            {
              pdf && pdf?.length > 0 &&
              <DownloadPDFWithFetch
                fileName={pdf}
                label=''
                className='!px-3.5'
                source={`${titulo}`}
                variant='outline'
                module='Visualizador de indicadores'
                icon={GrDocumentText}
              />
            }
          </div>
        </div>
      </div>
      <span className='text-system-light-40 text-blarge'>
        {highlight(descripcion)}
      </span>
      <div>
        <OdsChips ods={ods ?? []} />
        <PriorityGroupChips groups={grupos_prioritarios ?? []} />
      </div>
      <Dialog isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
        <Share newsTitle={titulo} newsUrl={href} description={descripcion} />
      </Dialog>
      <MethodologyNoteDialog
        isOpen={isOpenMetodologyNote}
        toggle={() => setIsOpenMetodologyNote(!isOpenMetodologyNote)}
        notas={'Para conocer más acerca de la ley, descarga el pdf'}
        documento_informativo={pdf}
      />
    </ResponsiveContainer>
  )
}

export default Laws